module.exports = __webpack_public_path__ + "img/ruletaVerde.1dc5b52f.png";